import { render } from "./Column.vue?vue&type=template&id=66b603b2"
import script from "./Column.vue?vue&type=script&lang=js"
export * from "./Column.vue?vue&type=script&lang=js"

import "./Column.vue?vue&type=style&index=0&id=66b603b2&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__